import React, { Fragment } from 'react';
import Datatable from '../../../../components/molecules/datatable';
import { TableColumns } from '../../configuration';
import * as VatRateSelectors from '../../../../redux/reducers/vat_rate_reducer/selectors';
import { useDispatch } from 'react-redux';
import VatRateActions from '../../../../redux/reducers/vat_rate_reducer/actions';
import useQuery from 'custom_hooks/useQuery';
import Filter from '../filter';

export default function DatatableList() {
  const result = VatRateSelectors.useGetVatRateList();
  const paging = result.data?.paging || {
    page: 0,
    pageSize: 25,
    total: 0,
  };
  const dispatch = useDispatch();
  const sortField = React.useRef<string>(TableColumns[0].id);
  const sortType = React.useRef<'asc' | 'desc'>('asc');

  const query = useQuery();
  const country_code = query.get('country_code');
  const vat_rate_type_id = query.get('vat_rate_type_id');
  const valid_from = query.get('valid_from');
  const valid_to = query.get('valid_to');
  const searchParams = {
    ...(country_code && { country_code }),
    ...(vat_rate_type_id && { vat_rate_type_id }),
    ...(valid_from && { valid_from }),
    ...(valid_to && { valid_to }),
  };

  return (
    <Fragment>
      <Filter
        country_code={country_code}
        vat_rate_type_id={vat_rate_type_id}
        valid_from={valid_from}
        valid_to={valid_to}
      />
      <Datatable
        loading={true}
        sorting={{
          sortField: sortField.current,
          order: sortType.current,
        }}
        paging={paging}
        data={result.data?.items || []}
        columns={TableColumns}
        changePageHandle={(selectedPage, pageSize, order, _sortField) => {
          sortType.current = order;
          sortField.current = _sortField;
          dispatch(
            VatRateActions.fetchVatRateListAction({
              sortField: _sortField,
              page: selectedPage,
              pageSize: pageSize,
              order: order,
              ...searchParams,
            })
          );
        }}
      />
    </Fragment>
  );
}
